/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package ppd
 * @since   1.0.0
 */

/**
 * Tooltips for filtered trial blocks
 *
 * @since 1.0.0
 */
import "./modules/theme/tooltips";

/**
 * BMI Filter Shortcode
 *
 * @since 1.0.0
 */
import "./modules/theme/bmi-filter-shortcode";

/**
 * Filterable Trials Functions
 *
 * @since 1.0.0
 */
import "./modules/theme/block-filterable-trials";

/**
 * Sharpspring Forms
 *
 * @since 1.0.0
 */
import "./modules/theme/sharpspring";

/**
 * Popup Form CTA Functions
 *
 * @since 1.0.0
 */
import "./modules/theme/block-popup-form-cta";

/**
 * Main Menu Modal Functions
 *
 * @since 1.0.0
 */
import "./modules/theme/main-menu-popup";
